import { Pipe, PipeTransform } from '@angular/core';
import {
  CalendarForDisplay,
  PriceConfig,
} from 'projects/photographer-panel/src/graphql';

@Pipe({
    name: 'pickCalendarPrice',
    standalone: false
})
export class PickCalendarPricePipe implements PipeTransform {
  transform(ratio: number, prices: CalendarForDisplay[]): PriceConfig[] {
    return (
      prices.find((p) =>
        ratio >= 1 ? p.size === 's20x30' : p.size === 's30x45',
      )?.price ?? []
    );
  }
}
